import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import withAuth from '../../hoc/with-auth';
import { push } from '../../services/router-utils';

class CreatePostHandler extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    categorySlug: PropTypes.string.isRequired,
    push: PropTypes.func.isRequired,
    forPublicUser: PropTypes.func.isRequired,
  };

  handleClick = () => {
    const { push, categorySlug } = this.props;

    push(`/${categorySlug}/create-post`);
  };

  render() {
    const { children, forPublicUser } = this.props;
    const child = React.Children.only(children);
    return React.cloneElement(child, { onClick: forPublicUser(this.handleClick) });
  }
}

const mapDispatchToProps = {
  push,
};

export default flowRight(
  connect(undefined, mapDispatchToProps),
  withAuth,
)(CreatePostHandler);



// WEBPACK FOOTER //
// ./app/containers/create-post-handler/create-post-handler.js